"use client";

import { Text } from "@/components/Text";

export function Footer() {
  return (
    <div className="grid text-center items-center justify-center w-full pb-4 border-t border-border-secondary pt-7">
      <Text>RISE Chain Testnet Faucet ©</Text>
      <Text variant="muted">Built with ♥ by RISE Labs</Text>
    </div>
  );
}
